// utils/simpleMode.ts — SATU-SATUNYA kebenaran "Mode Sederhana".
// Dua mode tanpa pilihan ongkir di halaman publik (ongkir dihitung sistem/CS
// setelah alamat dianalisis — customer diberi tahu CS):
//   1. "Form Sederhana" = addressInputMode 'none' TANPA javaOnly (Jawa punya ongkir).
//   2. "Mode Herbal"    = addressInputMode 'simple'.
// Konsekuensi: ongkir BELUM diketahui saat form dibuka → metode pembayaran
// TIDAK boleh tampil (anti customer TF/QRIS sebelum ongkir ada). Dipakai oleh
// ShippingMethodSection, PaymentMethodSection, dan useFormViewer (auto-select).
export function isSederhanaMode(form: any): boolean {
    const mode = form?.addressInputMode;
    if (mode === 'simple') return true;
    return mode === 'none' && !form?.javaOnly;
}
